import { useEffect } from 'react'

export default function HubSpotForm() {
  useEffect(() => {
    // Prevent loading the script multiple times
    if (document.getElementById('hubspot-form-script')) return

    const script = document.createElement('script')
    script.src = 'https://js-ap1.hsforms.net/forms/embed/46298402.js'
    script.defer = true
    script.id = 'hubspot-form-script'
    document.body.appendChild(script)
  }, [])

  return (
    <div
      className="hs-form-frame"
      data-region="ap1"
      data-form-id="a5425287-4138-48ef-b85a-5c30f90e7aa3"
      data-portal-id="46298402"
    />
  )
}
